import TaskHeaderViewer from "./task/components/TaskHeaderViewer";
import TaskHeaderEditor from "./task/components/TaskHeaderEditor";
import TaskHeader2 from "./task/components/TaskHeader2";
import TaskMini from "./task/components/TaskMini";
import TaskShortHand from "./task/components/TaskShortHand";
import TaskDashRow from "./task/components/TaskDashRow";

import ProjectTimesheet from "./components/ProjectTimesheet"
import ProjectTimesheetRow from "./components/ProjectTimesheetRow"
import ProjectHoldResumeEditor from "./components/ProjectHoldResumeEditor"
import ProjectHoldHistory from "./components/ProjectHoldHistory"

import cmnViewMap from '../cmn/Index';
import systemViewMap from '../system/Index';
import invViewMap from "../inv/Index";

const taskViewMap = {
    "vTaskHeaderViewer": TaskHeaderViewer,
    "vTaskHeaderEditor": TaskHeaderEditor,
    "vTaskHeader2":TaskHeader2,
    "vTaskMini":TaskMini,
    "vTaskShorthand":TaskShortHand,
    "vTaskDashRow":TaskDashRow,
    "vProjectTS":ProjectTimesheet,
    "vProjectTSRow":ProjectTimesheetRow,
    "vProjectHoldResumeEditor":ProjectHoldResumeEditor,
    "vProjectHoldHistory":ProjectHoldHistory,

    ...invViewMap,
    ...cmnViewMap,
    ...systemViewMap
}

export default taskViewMap;